import React, { useMemo } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const formatCustomerLabel = (customer) => {
  const parts = [customer.name || ""];
  if (customer.aadharCard) parts.push(`Aadhar: ${customer.aadharCard}`);
  if (customer.panCard) parts.push(`PAN: ${customer.panCard}`);
  return parts.filter(Boolean).join(" - ");
};

const toCustomerOption = (customer) => ({
  value: String(customer.borrowerId),
  label: formatCustomerLabel(customer),
  name: customer.name || "",
  aadharCard: customer.aadharCard || "",
  panCard: customer.panCard || "",
});

const filterCustomerOption = (option, inputValue) => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return true;
  const { name, aadharCard, panCard, label } = option.data || {};
  const haystack = `${name} ${aadharCard} ${panCard} ${label}`.toLowerCase();
  return haystack.includes(query);
};

const getSelectStyles = (isInvalid) => ({
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: isInvalid ? "#dc3545" : state.isFocused ? "#86b7fe" : "#ced4da",
    boxShadow: state.isFocused
      ? isInvalid
        ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25)"
        : "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
      : "none",
    "&:hover": {
      borderColor: isInvalid ? "#dc3545" : state.isFocused ? "#86b7fe" : "#ced4da",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
});

const CustomerSearchSelect = ({
  customers = [],
  value,
  onChange,
  disabled = false,
  isInvalid = false,
  placeholder,
  inputId,
}) => {
  const { t } = useTranslation();

  const options = useMemo(
    () => customers.map(toCustomerOption),
    [customers]
  );

  const selectedOption = options.find((opt) => opt.value === String(value)) || null;

  return (
    <Select
      inputId={inputId}
      options={options}
      value={selectedOption}
      onChange={(option) => onChange(option?.value || "")}
      isDisabled={disabled}
      isClearable
      isSearchable
      placeholder={placeholder}
      noOptionsMessage={() => t("customer.add.verificationModal.noCustomerFound")}
      filterOption={filterCustomerOption}
      className={isInvalid ? "is-invalid" : ""}
      classNamePrefix="customer-select"
      menuPortalTarget={document.body}
      styles={getSelectStyles(isInvalid)}
    />
  );
};

export default CustomerSearchSelect;
